export default __webpack_public_path__ + "static/media/10.4b75f57c.png";